var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCropsSunflower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7632 32.8618L20.9578 39.9671C20.3964 39.4992 19.9071 38.8981 19.4122 38.2902C18.3414 36.9747 17.2443 35.6269 15.3328 35.5263C10.9464 35.2954 6.92008 35.4246 4.79804 35.4927C4.19883 35.5119 3.75146 35.5263 3.4907 35.5263C2.30649 35.5263 2.8986 41.4473 9.41175 42.6316C13.848 43.4382 20.9578 42.6316 20.9578 42.6316V45H21.9474H22.142H23.1316V42.6316C23.1316 42.6316 30.2413 43.4382 34.6776 42.6316C41.1908 41.4473 41.7829 35.5263 40.5987 35.5263C40.3379 35.5263 39.8906 35.5119 39.2913 35.4927C37.1693 35.4246 33.143 35.2954 28.7566 35.5263C26.8451 35.6269 25.748 36.9747 24.6772 38.2902C24.1823 38.8981 23.693 39.4992 23.1316 39.9671L23.4276 32.8618C23.4276 32.8618 23.1724 33.2084 22.8355 33.4539C22.614 33.6154 22.2253 33.7012 22.0447 33.734C21.8641 33.7012 21.4754 33.6154 21.2539 33.4539C20.917 33.2084 20.7632 32.8618 20.7632 32.8618Z",
    fill: "#36965C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1314 27.2368C21.9472 27.5329 21.9472 27.5329 20.763 27.2368C20.763 28.0827 19.8748 29.5124 19.8748 30.3584C19.8748 31.6272 21.4866 32.8618 21.9472 32.8618C22.4077 32.8618 24.0195 31.6274 24.0195 30.3584C24.0195 29.5124 23.1314 28.0827 23.1314 27.2368Z",
    fill: "#EBC905"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7632 5.625C21.9474 5.32895 21.9474 5.32895 23.1316 5.625C23.1316 4.77907 24.0197 3.34938 24.0197 2.50345C24.0197 1.23463 22.4079 -4.76837e-07 21.9473 -4.76837e-07C21.4868 -4.76837e-07 19.875 1.23441 19.875 2.50345C19.875 3.34938 20.7632 4.77908 20.7632 5.625Z",
    fill: "#EBC905"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3734 25.197C27.4959 26.0455 27.4959 26.0455 26.3223 26.3812C26.7453 27.1138 26.6909 28.796 27.1139 29.5286C27.7483 30.6275 29.7615 30.8908 30.1604 30.6605C30.5592 30.4302 31.3379 28.5553 30.7034 27.4563C30.2804 26.7237 28.7964 25.9296 28.3734 25.197Z",
    fill: "#EBC905"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5172 7.66481C16.3947 6.81631 16.3947 6.81631 17.5683 6.4806C17.1454 5.748 17.1997 4.06577 16.7767 3.33318C16.1423 2.23434 14.1291 1.97105 13.7302 2.20133C13.3314 2.43157 12.5527 4.30652 13.1873 5.40555C13.6102 6.13814 15.0943 6.93222 15.5172 7.66481Z",
    fill: "#EBC905"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8977 20.8084C31.562 21.9819 31.562 21.9819 30.7135 22.8595C31.4461 23.2824 32.2402 24.7664 32.9728 25.1894C34.0716 25.8238 35.9467 25.0452 36.177 24.6464C36.4073 24.2476 36.1442 22.2345 35.0451 21.6C34.3125 21.177 32.6303 21.2313 31.8977 20.8084Z",
    fill: "#EBC905"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9968 12.0535C12.3325 10.8799 12.3325 10.8799 13.181 10.0024C12.4484 9.57945 11.6544 8.09543 10.9218 7.67247C9.82293 7.03806 7.94779 7.81664 7.7175 8.2155C7.48726 8.6143 7.75037 10.6274 8.84939 11.2619C9.58199 11.6849 11.2642 11.6306 11.9968 12.0535Z",
    fill: "#EBC905"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.752 15.2467C33.048 16.4309 33.048 16.4309 32.752 17.6152C33.5979 17.6152 35.0276 18.5033 35.8735 18.5033C37.1423 18.5033 38.377 16.8915 38.377 16.4309C38.377 15.9704 37.1425 14.3586 35.8735 14.3586C35.0276 14.3586 33.5979 15.2467 32.752 15.2467Z",
    fill: "#EBC905"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1406 17.6151C10.8446 16.4309 10.8446 16.4309 11.1406 15.2467C10.2947 15.2467 8.865 14.3586 8.01907 14.3586C6.75025 14.3586 5.51562 15.9704 5.51562 16.431C5.51562 16.8915 6.75003 18.5033 8.01907 18.5033C8.865 18.5033 10.2947 17.6151 11.1406 17.6151Z",
    fill: "#EBC905"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7136 10.0024C31.5621 10.8799 31.5621 10.8799 31.8978 12.0535C32.6304 11.6305 34.3126 11.6849 35.0452 11.2619C36.1441 10.6275 36.4074 8.61427 36.1771 8.2154C35.9468 7.81661 34.0719 7.03792 32.9729 7.67244C32.2403 8.0954 31.4462 9.57942 30.7136 10.0024Z",
    fill: "#EBC905"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1809 22.8594C12.3324 21.9819 12.3324 21.9819 11.9967 20.8083C11.2641 21.2313 9.58188 21.177 8.84929 21.5999C7.75046 22.2343 7.48716 24.2476 7.71744 24.6464C7.94769 25.0452 9.82263 25.8239 10.9217 25.1894C11.6543 24.7664 12.4483 23.2824 13.1809 22.8594Z",
    fill: "#EBC905"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3239 6.48064C27.4974 6.81636 27.4974 6.81636 28.375 7.66485C28.7979 6.93226 30.2819 6.13818 30.7049 5.40559C31.3393 4.30675 30.5607 2.43161 30.1619 2.20133C29.7631 1.97109 27.75 2.23419 27.1155 3.33322C26.6925 4.06581 26.7468 5.74805 26.3239 6.48064Z",
    fill: "#EBC905"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5687 26.3812C16.3951 26.0455 16.3951 26.0455 15.5176 25.197C15.0946 25.9296 13.6106 26.7237 13.1877 27.4563C12.5533 28.5551 13.3318 30.4303 13.7307 30.6605C14.1295 30.8908 16.1426 30.6277 16.7771 29.5287C17.2001 28.7961 17.1458 27.1138 17.5687 26.3812Z",
    fill: "#EBC905"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9463,
    cy: 16.579,
    r: 9.47368,
    fill: "#E38F52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsSunflower);
export default __webpack_public_path__ + "static/media/ic-crops-Sunflower.17a381858ee5e3a7e35b5430c1eb23c7.svg";
export { ForwardRef as ReactComponent };